import React, { useEffect, useState } from 'react';
import { useTranslate } from '../../components/TranslationText';
import EahsForm from '../../components/EahsForm';
import NetaqInput from '../../components/NetaqInput';
import Loader from '../../components/Loader';
import SimpleUpload from '../../components/SimpleFileUpload';
import { eFormButtonsContainer, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle } from '../../common/cssclasses';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import axiosInstance from '../../axios/axios';
import { validateInputs } from '../../helper/validaiteInputs';
import CustomPopUp from '../../components/CustomPopUp';
import { useLocation, useNavigate } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';


function ChulibPage() {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const currentId = searchParams.has("id") ? searchParams.get("id") : null;
    const { translate } = useTranslate();
    const initialState = {
        NameEn: '',
        NameAr: '',
        Email: '',
        Mobile: '',
        BankName: '',
        BneficiaryName: '',
        Iban: '',
        BankAccountNumber: '',
        SwiftCode: '',
        BankCountryId: '',
        CurrencyId: '',
    };

    const [invalidIban, setInvalidIBAN] = useState(false);
    const [formData, setFormData] = useState(initialState);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const [nationalId, setNationalIdFiles] = useState([]);
    const [profileImage, setProfileImage] = useState([]);
    const [ibanCertificate, setIbanCertificate] = useState([]);
    const [curenciesOptions, setCurenciesOptions] = useState([]);
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [teamOptions, setTeamsOptions] = useState([]);
    const handleNationalIdUpload = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }

            setNationalIdFiles(fileListHook);
        }
    };
    const handleProfileImageUpload = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }

            setProfileImage(fileListHook);
        }
    };
    const handleIbanCertificateUpload = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }
            setIbanCertificate(fileListHook);
        }
    };

    const setPhoneNumber = (value) => {
        setFormData((prev) => ({
            ...prev,
            'Mobile': value
        }));
    }

    const handleChange = (event) => {
        setFormData((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    }

    async function getcurrencyList() {
        try {
            const currencylist = await axiosInstance.get('/lookup/getcurrencies');
            const formattedData = currencylist?.data?.result.map((x) => ({
                label: x?.text,
                ...x
            }))
            setCurenciesOptions(formattedData ?? []);
        } catch (error) {
            window.alert('error in currency list')
        }
    }
    async function getCountriesList() {
        try {
            const nationalityList = await axiosInstance.get('/nationality')
            const formattedData = await nationalityList.data.result.map((item) => ({
                text: item.name,
                label: item.name,
                value: item.id,
            }));

            setCountriesOptions(formattedData)
        } catch (error) {
        }
    }

    async function getShowDetails(showId = '52e28a6e-f254-436b-8014-4c211cb0adab') {
        try {
            const res = await axiosInstance.get(`/chulipshows/getchulipbyid?showId=${showId}`)
            const formattedData = res.data?.result ?? {};
            setShowDetails(formattedData)
            const teams = res.data?.result?.teams?.map((x) => ({
                text: x.teamName,
                label: x.teamName,
                value: x.teamId,
                isDisabled: x.isCompletedRegister,
                ...x
            }))
            setTeamsOptions(teams);
        } catch (error) {

        }

    }
    useEffect(() => {
        getcurrencyList();
        getCountriesList();
        getShowDetails(currentId);
    }, [])

    useEffect(() => {
        if ((formData?.Iban?.length < 14 || formData?.Iban?.length > 35) ?? false) {
            setInvalidIBAN(true);
        } else {
            setInvalidIBAN(false);
        }
    }, [formData]);

    async function submitForm() {
        setIsSubmitting(true)
        const valid = validateInputs(formData, toast, translate)
        if (valid) {
            const sendFormData = new FormData();
            for (const [key, value] of Object.entries(formData)) {
                sendFormData.append(key, value);

            }
            if (profileImage?.length <= 0) {
                const message = translate('web.profileImage', 'Profile Image') + " " + translate('web.isRequired')
                toast.error(message);
                return;
            }
            if (nationalId?.length <= 0) {
                const message = translate('web.idCopy', 'Id Copy') + " " + translate('web.isRequired')
                toast.error(message);
                return;
            }
            if (ibanCertificate?.length <= 0) {
                const message = translate('web.ibanCertificate', 'Iban Certificate') + " " + translate('web.isRequired')
                toast.error(message);
                return;
            }
            sendFormData.append('PersonalImage', profileImage[0].file ?? null);
            sendFormData.append('IdOrPassport', nationalId[0].file ?? null);
            sendFormData.append('IbanCertificate', ibanCertificate[0].file ?? null);

            const req = await axiosInstance.post('/chulipshows/registrationhorseman', sendFormData, {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            })
            if (req.status == 200) {
                if (req.data?.status?.responseCode == '200') {
                    toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'));
                    resetForm();
                    setTimeout(() => {
                        navigate('/');
                    }, 3000);
                } else {
                    toast.error(translate(req.data?.status?.detailedResponseCode, req.data?.status?.detailedResponseCode))
                }
            }
            setIsSubmitting(false)
        } else {
            setIsSubmitting(false)
            return;
        }

    }

    function resetForm() {
        setFormData(initialState);
        setProfileImage([])
        setNationalIdFiles([])
        setIbanCertificate([]);
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            <div className={serviceRequestHeadContainer}>
                <h2 className={serviceRequestTitle + " d-flex align-items-center flex-wrap"}>
                    {/* <img src={showDetails?.logoUrl}
                        className="me-3 bg-white"
                        alt={showDetails?.logoUrl}
                        style={{ maxHeight: 60 }}
                        onError={(e) => e.currentTarget.classList.add('d-none')}
                    /> */}
                    {translate('web.registerFor', 'Register For') + " " + showDetails?.name}
                </h2>
            </div>

            <EahsForm isSectionTitle className={'mb-main'} ish3 >
                {/* <div className={eformInput}>
                    <NetaqInput
                        type='select'
                        name='Team'
                        label={translate('web.selectTeam', 'Select Team')}
                        placeholder={translate('web.selectTeam', 'Select Team')}
                        listSelect={teamOptions}
                        required
                        onChange={(selectItem) => {
                            setFormData((prev) => ({
                                ...prev,
                                TeamId: selectItem.value,
                            }));
                        }}
                    />
                </div> */}
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='NameEn'
                        label={translate('web.FullnameEn', 'Full Name En')}
                        placeholder={translate('web.FullnameEn', 'Full Name En')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='text'
                        name='NameAr'
                        label={translate('web.FullNameAr', 'Full Name En')}
                        placeholder={translate('web.FullNameAr', 'Full Name En')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type='email'
                        name='Email'
                        label={translate('web.Email', 'Email')}
                        placeholder={translate('web.Email', 'Email')}
                        required
                        onChange={handleChange}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={'phone'}
                        label={translate("web.mobileNo", "Mobile No")}
                        name={'phone'}
                        placeholder={'971xxxxxxxxx'}
                        required={true}
                        onChange={setPhoneNumber}
                        setIsPhoneNumberValid={setIsPhoneNumberValid} />
                    {!isPhoneNumberValid &&
                        <div className='text-danger'>
                            {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                        </div>}
                </div>
            </EahsForm>
            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate('web.bankDetails', 'Bank Details')} >

                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        label={translate("web.bankName", "Bank Name")}
                        placeholder={translate("web.bankName", "Bank Name")}
                        name={"BankName"}
                        onChange={handleChange}
                        required={true}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        label={translate("web.bneficiaryName", "Bneficiary Name")}
                        placeholder={translate("web.bneficiaryName", "Bneficiary Name")}
                        name={"BneficiaryName"}
                        onChange={handleChange}
                        value={formData?.BneficiaryName}
                        required={true}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        label={translate("web.iban", "IBAN")}
                        placeholder={translate("web.iban", "Iban")}
                        name={"Iban"}
                        key={"IBAN"}
                        onChange={handleChange}
                        required={true}
                    />
                    {formData?.Iban?.length > 0 && invalidIban &&
                        <div className='text-danger text-center'>
                            {translate('web.invalidIban', 'Invalid IBAN')}
                        </div>
                    }
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        label={translate("web.bankAccountNumber", "bank Account Number")}
                        placeholder={translate("web.bankAccountNumber", "bank Account Number")}
                        name={"BankAccountNumber"}
                        onChange={handleChange}
                        required={true}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"text"}
                        label={translate("web.swiftCode", "Swift Code")}
                        placeholder={translate("web.swiftCode", "Swift Code")}
                        name={"SwiftCode"}
                        onChange={handleChange}
                        required={true}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"select"}
                        label={translate("web.bankCountry", "Bank Country")}
                        placeholder={translate("web.bankCountry", "Bank Country")}
                        name={"bankCountryId"}
                        listSelect={countriesOptions}
                        value={countriesOptions.length > 0 ? countriesOptions.find((item) => item.value === formData?.BankCountryId) : ""}
                        onChange={(selectItem) => {
                            setFormData((prev) => ({
                                ...prev,
                                BankCountryId: selectItem.value,
                            }));
                        }}
                        required={true}
                    />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"select"}
                        label={translate("web.curency", "Curency")}
                        placeholder={translate("web.curency", "curency")}
                        name={"currencyId"}
                        listSelect={curenciesOptions}
                        value={curenciesOptions.length > 0 ? curenciesOptions.find((item) => item.value === formData?.CurrencyId) : ""}
                        onChange={(selectItem) => {
                            setFormData((prev) => ({
                                ...prev,
                                CurrencyId: selectItem.value,
                            }));
                        }}
                        required={true}

                    />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.ibanCertificate', 'IBAN Certificate')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={ibanCertificate} onChange={handleIbanCertificateUpload} key={'ibanCertificate'} />
                </div>
            </EahsForm>
            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate('web.attachments', 'attachment')}>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.idCopy', 'ID Copy')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={nationalId} onChange={handleNationalIdUpload} key={'nationalId'} />
                </div>
                <div className={eformInput}>
                    <label className="capatalize_text">
                        {translate('web.profileImage', 'Profile Image')} <span className="color-eahsred" >*</span>
                    </label>
                    <SimpleUpload accept="image/*" isMulti={false} isServer={false} initialFiles={profileImage} onChange={handleProfileImageUpload} key={'Profile Image'} />
                </div>
            </EahsForm>
            {!!showDetails?.termsAndConditions &&
                <div className={eformTerms + " my-3"}>
                    <CustomPopUp
                        key={'terms'}
                        trigger={
                            <NetaqInput
                                key={'termsAndConditions' + "123"}
                                type='checkbox'
                                name='termsAndConditions'
                                label={translate('web.iAgreeToTheTermsAndConditions', 'I Agree To The Terms And Conditions')}
                                checked={acceptTerms}
                                onChange={(e) => setAcceptTerms(e?.target?.checked)}
                            />
                        }
                        title={translate('web.termsAndConditions', 'Terms And Conditions')}
                        content={
                            <>
                                <div dangerouslySetInnerHTML={{ __html: showDetails?.termsAndConditions }} />
                            </>
                        }
                    />
                </div>
            }
            <div className={eFormButtonsContainer}>

                {/* submit btn */}
                {isSubmitting ?
                    <Loader /> :

                    <SubmitServiceBtn
                        onClick={submitForm}
                        disabled={!acceptTerms}
                    />
                }
            </div>
        </>
    );
}

export default ChulibPage;